module.exports = __webpack_public_path__ + "resources/img/img_t3q_search_m_jp.180d1037f2ed0127f9ec442ddd2dbf09.png";